<template>
  <div
    :class="{
      'is-dragover': dragover
    }"
    class="el-upload-dragger"
    @drop.prevent="onDrop"
    @dragover.prevent="onDragover"
    @dragleave.prevent="dragover = false"
  >
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'ElUploadDrag',
  props: {
    disabled: Boolean
  },
  inject: {
    uploader: {
      default: ''
    },
    elForm: {
      default: ''
    }
  },
  data () {
    return {
      dragover: false
    };
  },
  computed: {
    computedDisabled () {
      return this.disabled || (this.elForm || {}).disabled;
    }
  },
  methods: {
    onDragover () {
      if (!this.computedDisabled) {
        this.dragover = true;
      }
    },
    onDrop (e) {
      if (this.computedDisabled || !this.uploader) return;
      const accept = this.uploader.accept;
      this.dragover = false;
      if (!accept) {
        this.$emit('file', e.dataTransfer.files);
        return;
      }
      this.$emit(
        'file',
        [].slice.call(e.dataTransfer.files).filter(file => {
          const { type, name } = file;
          const extension = name.indexOf('.') > -1 ? `.${name.split('.').pop()}` : '';
          const baseType = type.replace(/\/.*$/, '');
          return accept
            .split(',')
            .map(_type => _type.trim())
            .filter(_type => _type)
            .some(acceptedType => {
              if (/\..+$/.test(acceptedType)) {
                return extension === acceptedType;
              }
              if (/\/\*$/.test(acceptedType)) {
                return baseType === acceptedType.replace(/\/\*$/, '');
              }
              if (/^[^/]+\/[^/]+$/.test(acceptedType)) {
                return type === acceptedType;
              }
              return false;
            });
        })
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// upload-dragger.vue?c7d38ab0